export const toFixed = (num: number) => Number(num).toFixed(2);
